import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const ChapterPrevious = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='ChapterPrevious' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M23,3.5 L23,20 L14,14 L14,20 L3,12 L14,4 L14,10 L23,3.5 Z M2,2 L2,22 L2,2 Z' />
  </StyledIcon>
);
